// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d_kFp","icon":"styles_icon__1Wpz9"};